/* =========================================================
   SPRAY REMOVEDOR DE ÓXIDO — Lógica de la landing
   Prefijo global: window.SO_
   ========================================================= */

/* ------------------------------------------------------------------
   1) CONFIGURACIÓN CENTRALIZADA
   Cambia aquí lo que necesites. Todo está comentado.
   ------------------------------------------------------------------ */
window.MI_CONFIG = {
  /* App / método de checkout. Ver CHECKOUT_APP abajo. */
  checkoutApp: "releasit",          // "releasit" | "shopify" | "custom"

  /* Countdown de oferta (en HORAS). Se reinicia por navegador. */
  countdownHours: 3,

  /* Reinicia el contador cada vez que llega a 0 (urgencia perpetua). */
  countdownLoop: true,

  /* Texto del botón principal segun el metodo elegido. */
  ctaText: "AÑADIR A LA CESTA",
  ctaTextCod: "COMPRAR AHORA — PAGO CONTRA ENTREGA",

  /* Autoplay del mini-slider de reseñas (ms). 0 = desactivado. */
  miniReviewInterval: 5000,

  /* A dónde va el botón con Releasit COD tras añadir a la cesta.
     Déjalo en "/checkout" (Releasit intercepta y muestra su formulario).
     Si usas el formulario COD en la página de producto, ponlo en "/cart". */
  releasitCheckoutUrl: "/checkout"
};

/* ------------------------------------------------------------------
   2) CHECKOUT_APP — Conexión del botón de compra
   ------------------------------------------------------------------
   "releasit" -> Deja el <form> estándar de Shopify (/cart/add).
                 La app Releasit Cash on Delivery detecta el producto
                 y muestra su formulario COD automáticamente. No hay
                 que tocar nada más aquí; solo tener la app instalada
                 y activa para este producto.
   "shopify"  -> Añade a la cesta y redirige a /checkout nativo.
   "custom"   -> Redirige a la URL que definas en CUSTOM_CHECKOUT_URL
                 con la variante y cantidad en el query string.
   ------------------------------------------------------------------ */
window.CHECKOUT_APP = window.MI_CONFIG.checkoutApp;   // no editar: lee de MI_CONFIG
window.CUSTOM_CHECKOUT_URL = "";                      // solo si CHECKOUT_APP = "custom"

(function () {
  "use strict";

  function ready(fn){
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  ready(function () {
    var root = document.querySelector("[data-so-root]");
    if (!root) return;

    /* ---------- Galería ---------- */
    var mainImg = root.querySelector("[data-so-main-img]");
    root.querySelectorAll("[data-so-thumb]").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var src = thumb.getAttribute("data-src");
        if (mainImg && src) mainImg.src = src;
        root.querySelectorAll("[data-so-thumb]").forEach(function (t) { t.classList.remove("is-active"); });
        thumb.classList.add("is-active");
      });
    });

    /* ---------- Variantes / combos ---------- */
    var form = root.querySelector("[data-so-form]");
    var idInput = root.querySelector("[data-so-variant-id]");
    var priceEl = root.querySelector("[data-so-price]");
    var compareEl = root.querySelector("[data-so-compare]");
    var saveEl = root.querySelector("[data-so-save]");
    var stickyPrice = root.querySelector("[data-so-sticky-price]");

    function selectVariant(label) {
      root.querySelectorAll("[data-so-variant]").forEach(function (v) {
        var on = v === label;
        v.classList.toggle("is-active", on);
        var input = v.querySelector("input");
        if (input) input.checked = on;
      });
      var id = label.getAttribute("data-variant-id");
      var price = label.getAttribute("data-price");
      var compare = label.getAttribute("data-compare");
      var save = label.getAttribute("data-save");
      if (idInput) idInput.value = id;
      if (priceEl && price) priceEl.textContent = price;
      if (compareEl) {
        if (compare) { compareEl.textContent = compare; compareEl.style.display = ""; }
        else compareEl.style.display = "none";
      }
      if (saveEl) {
        if (save) { saveEl.textContent = save; saveEl.style.display = ""; }
        else saveEl.style.display = "none";
      }
      if (stickyPrice) {
        stickyPrice.innerHTML = (price || "") + (compare ? " <s>" + compare + "</s>" : "");
      }
    }

    var variants = root.querySelectorAll("[data-so-variant]");
    variants.forEach(function (v) {
      v.addEventListener("click", function () { selectVariant(v); });
    });
    if (variants.length) {
      var pre = root.querySelector("[data-so-variant].is-active") || variants[0];
      selectVariant(pre);
    }

    /* ---------- Añadir a la cesta / Checkout ---------- */
    function toast(msg){
      var t = root.querySelector("[data-so-toast]");
      if (!t) return;
      t.textContent = msg;
      t.classList.add("show");
      setTimeout(function(){ t.classList.remove("show"); }, 2600);
    }

    function addToCart(e){
      if (e) e.preventDefault();
      var id = idInput ? idInput.value : null;
      if (!id) return;

      // En el editor / preview no hay backend de Shopify.
      var isShopify = typeof window.Shopify !== "undefined" && form && form.action.indexOf("/cart/add") > -1;

      if (window.CHECKOUT_APP === "custom" && window.CUSTOM_CHECKOUT_URL) {
        window.location.href = window.CUSTOM_CHECKOUT_URL +
          (window.CUSTOM_CHECKOUT_URL.indexOf("?") > -1 ? "&" : "?") +
          "variant=" + encodeURIComponent(id) + "&quantity=1";
        return;
      }

      if (!isShopify) {                 // preview
        toast("✔ Añadido a la cesta (vista previa)");
        return;
      }

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (window.CHECKOUT_APP === "releasit") {
          // Releasit Cash on Delivery muestra su formulario en el checkout.
          // Añadimos a la cesta y vamos directo al checkout, donde
          // Releasit intercepta y despliega el formulario COD.
          document.dispatchEvent(new CustomEvent("releasit:cod:trigger"));
          window.location.href = window.MI_CONFIG.releasitCheckoutUrl || "/checkout";
        } else {
          window.location.href = "/checkout";
        }
      })
      .catch(function () { toast("No se pudo añadir. Intenta de nuevo."); });
    }

    root.querySelectorAll("[data-so-add]").forEach(function (btn) {
      btn.addEventListener("click", addToCart);
    });
    if (form) form.addEventListener("submit", addToCart);

    /* ---------- Etiqueta del CTA según método ---------- */
    var ctaLabel = window.CHECKOUT_APP === "releasit"
      ? window.MI_CONFIG.ctaTextCod
      : window.MI_CONFIG.ctaText;
    root.querySelectorAll("[data-so-cta-label]").forEach(function (el) { el.textContent = ctaLabel; });

    /* ---------- Countdown ---------- */
    var cd = root.querySelector("[data-so-countdown]");
    if (cd) {
      var hEl = cd.querySelector("[data-cd-h]");
      var mEl = cd.querySelector("[data-cd-m]");
      var sEl = cd.querySelector("[data-cd-s]");
      var totalMs = (window.MI_CONFIG.countdownHours || 3) * 3600 * 1000;
      var key = "so_countdown_end";
      var end = parseInt(localStorage.getItem(key) || "0", 10);
      var now = Date.now();
      if (!end || end < now) { end = now + totalMs; localStorage.setItem(key, String(end)); }

      function pad(n){ return (n < 10 ? "0" : "") + n; }
      function tick(){
        var diff = end - Date.now();
        if (diff <= 0) {
          if (window.MI_CONFIG.countdownLoop) {
            end = Date.now() + totalMs; localStorage.setItem(key, String(end)); diff = totalMs;
          } else { diff = 0; }
        }
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        if (hEl) hEl.textContent = pad(h);
        if (mEl) mEl.textContent = pad(m);
        if (sEl) sEl.textContent = pad(s);
      }
      tick();
      setInterval(tick, 1000);
    }

    /* ---------- Acordeones (info + FAQ) ---------- */
    root.querySelectorAll("[data-so-acc]").forEach(function (acc) {
      var head = acc.querySelector("[data-so-acc-head]");
      var body = acc.querySelector("[data-so-acc-body]");
      if (!head || !body) return;
      head.addEventListener("click", function () {
        var open = acc.classList.toggle("is-open");
        body.style.maxHeight = open ? body.scrollHeight + "px" : "0px";
      });
    });

    /* ---------- Mini slider de reseñas ---------- */
    var mini = root.querySelector("[data-so-mini]");
    if (mini) {
      var track = mini.querySelector("[data-so-mini-track]");
      var slides = mini.querySelectorAll(".so-mini-slide");
      var i = 0;
      function go(n){
        i = (n + slides.length) % slides.length;
        track.style.transform = "translateX(-" + (i * 100) + "%)";
      }
      var prev = mini.querySelector(".so-mini-nav.prev");
      var next = mini.querySelector(".so-mini-nav.next");
      if (prev) prev.addEventListener("click", function(){ go(i - 1); });
      if (next) next.addEventListener("click", function(){ go(i + 1); });
      var iv = window.MI_CONFIG.miniReviewInterval;
      if (iv > 0 && slides.length > 1) setInterval(function(){ go(i + 1); }, iv);
    }
  });
})();
